var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-alert py-2 px-3 font-size-small d-flex align-items-center",class:_vm.cssClass},[(_vm.type === 'success')?[_c('BaseIcon',[_c('CheckCircledIcon')],1)]:_vm._e(),_c('span',[_vm._v(_vm._s(_vm.content))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }